import React from 'react'

import { makeAppStyles } from '@percept/mui'

import { DashboardCardFallbackContent } from 'components/DashboardCard'

export const errorContent = (
  <DashboardCardFallbackContent>Data could not be loaded</DashboardCardFallbackContent>
)


export const useDashboardCardButtonStyles = makeAppStyles( theme => ({
  triggerButton: {
    height: 22,
    fontSize: 12,
    padding: theme.spacing(0, 1),
    '& .MuiButton-endIcon': {
      marginLeft: 4,
    },
  },
}))
